import { render, staticRenderFns } from "./ProjectIssues.vue?vue&type=template&id=5fe3548e&scoped=true"
import script from "./ProjectIssues.vue?vue&type=script&lang=js"
export * from "./ProjectIssues.vue?vue&type=script&lang=js"
import style0 from "./ProjectIssues.vue?vue&type=style&index=0&id=5fe3548e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe3548e",
  null
  
)

export default component.exports